import React from "react"

import { withInstagram } from "./withInstagram"
import { Inner, Overlay, Wrapper, Title, User } from "./InstagramStyles"
import { Image } from "../../Image/Image"

export const Instagram = withInstagram(
  ({ items, title, user }): JSX.Element => (
    <Wrapper>
      {items.map(item => (
        <Inner as={"a"} key={item.id} href={item.link.url} title={item.link.title} target={"_blank"} className={"group"}>
          <Image image={item.image} />
          <Overlay>
            <Title>{title}</Title>
            <User>{user}</User>
          </Overlay>
        </Inner>
      ))}
    </Wrapper>
  )
)

export default Instagram
